export const columnClientList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "address",
    label: "Address",
    filter: false,
    sorter: false
  },
  {
    key: "description",
    label: "Description",
    filter: false,
    sorter: false
  },
  {
    key: "total_project",
    label: "Total Project",
    filter: false,
    sorter: false
  },
  {
    key: "pic_name",
    label: "PIC Name",
    filter: false,
    sorter: true
  },
  {
    key: "pic_contact_number",
    label: "PIC Contact Number",
    filter: false,
    sorter: false
  },
  {
    key: "createdAt",
    label: "Date Added",
    filter: false,
    sorter: true
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnProjectList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
  {
    key: "tax_value",
    label: "Tax and other fees",
    filter: false,
    sorter: true
  },
  {
    key: "start_date",
    label: "Start Date",
    filter: false,
    sorter: true
  },
  {
    key: "end_date",
    label: "End Date",
    filter: false,
    sorter: true
  },
  {
    key: "client_name",
    label: "Client",
    filter: false,
    sorter: true
  },
  {
    key: "createdAt",
    label: "Date Added",
    filter: false,
    sorter: true
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnInvoiceList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
  {
    key: "client_name",
    label: "Client",
    filter: false,
    sorter: true
  },
  {
    key: "createdAt",
    _style: { width: '25%' },
    label: "Created Date",
    filter: false,
    sorter: true
  },
  {
    key: "invoice_payment",
    label: "Payment",
    filter: false,
    sorter: false
  },
  {
    key: "status_invoice",
    label: "Status",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnExpenseList = [
  {
    key: "category_name",
     _style: { width: '20%' },
    label: "Expense category",
    filter: false,
    sorter: true
  },
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
  {
    key: "date",
    label: "Expense date",
    filter: false,
    sorter: true
  },
  {
    key: "project_name",
    _style: { width: '20%' },
    label: "Project related",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnPayrollList = [
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
  {
    key: "tax_value",
    label: "Tax Value",
    filter: false,
    sorter: true
  },
  {
    key: "date",
    label: "Date",
    filter: false,
    sorter: true
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnAssetList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
  {
    key: "register_date",
    label: "Date",
    filter: false,
    sorter: true
  },
  {
    key: "is_cash",
    label: "Cash?",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnEmployeeList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "employee_no",
    label: "Employee No",
    filter: false,
    sorter: true
  },
  {
    key: "contact_number",
    label: "Phone Number",
    filter: false,
    sorter: false
  },
  {
    key: "status",
    label: "Status",
    filter: false,
    sorter: false
  },
  {
    key: "is_active",
    label: "Active?",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnCashflowPositionList = [
  {
    key: "month",
    label: "Month",
    filter: false,
    sorter: true
  },
  {
    key: "cash_inflow",
    label: "Cash inflow",
    filter: false,
    sorter: true
  },
  {
    key: "cash_outflow",
    label: "Cash outflow",
    filter: false,
    sorter: true
  },
  {
    key: "balance",
    label: "Balance",
    filter: false,
    sorter: true
  }
]

export const columnSupportingLinksList = [
  {
    key: "file_name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "file_description",
    label: "Description",
    filter: false,
    sorter: false
  },
  {
    key: "file_url",
    label: "File",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnLetterNumberList = [
  {
    key: "letter_type",
    label: "Type",
    filter: false,
    sorter: false
  },
  {
    key: "letter_number",
    label: "Number",
    filter: false,
    sorter: true
  },
  {
    key: "letter_recipient",
    label: "Recipient",
    filter: false,
    sorter: true
  },
  {
    key: "createdAt",
    label: "Date",
    filter: false,
    sorter: true
  },
  {
    key: "letter_notes",
    label: "Notes",
    filter: false,
    sorter: false
  },
  {
    key: "copy",
    label: "Copy",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnCompanyBankAccountList = [
  {
    key: "account_name",
    label: "Account Name",
    filter: false,
    sorter: true
  },
  {
    key: "account_number",
    label: "Account Number",
    filter: false,
    sorter: true
  },
  {
    key: "bank_name",
    label: "Bank Name",
    filter: false,
    sorter: false
  },
  {
    key: "is_default_bank",
    label: "Default Bank?",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnUserList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: false
  },
  {
    key: "username",
    label: "Username",
    filter: false,
    sorter: false
  },
  {
    key: "email",
    label: "Email",
    filter: false,
    sorter: false
  },
  {
    key: "contact_number",
    label: "Phone Number",
    filter: false,
    sorter: false
  },
  {
    key: "role",
    label: "Role",
    filter: false,
    sorter: false
  },
  {
    key: "is_active",
    label: "Active?",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnSalaryDetailsList = [
  {
    key: "name",
    label: "Title",
    filter: false,
    sorter: true
  },
  {
    key: "value",
    label: "Value",
    filter: false,
    sorter: true
  },
]

export const columnCompanyPolicyList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "number",
    label: "Number",
    filter: false,
    sorter: true
  },
  {
    key: "description",
    label: "Description",
    filter: false,
    sorter: true
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnPolicyTypeList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: true
  },
  {
    key: "description",
    label: "Description",
    filter: false,
    sorter: true
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnTimeOffRequestList = [
  {
    key: "reference",
    label: "Request ID",
    filter: false,
    sorter: false
  },
  {
    key: "employee_name",
    label: "Employee Name",
    filter: false,
    sorter: true
  },
  {
    key: 'employee_status',
    label: 'Employee Status',
    filter: false,
    sorter: false
  },
  {
    key: "time_off_type",
    label: "Type of Leave",
    filter: false,
    sorter: false
  },
  {
    key: "duration",
    label: "Duration",
    filter: false,
    sorter: false
  },
  {
    key: "submission_date",
    label: "Submission Date",
    filter: false,
    sorter: false
  },
  {
    key: "status",
    label: "Status",
    filter: false,
    sorter: false
  }
]

export const columnTimeOffBalanceList = [
  {
    key: "employee_name",
    label: "Employee Name",
    filter: false,
    sorter: true
  },
  {
    key: "employee_status",
    label: "Employee Status",
    filter: false,
    sorter: false
  },
  {
    key: "accrued_balance",
    label: "Accrued",
    filter: false,
    sorter: false
  },
  {
    key: "used_balance",
    label: "Used",
    filter: false,
    sorter: false
  },
  {
    key: "available_balance",
    label: "Available",
    filter: false,
    sorter: false
  },
  {
    key: "updatedAt",
    label: "Last Updated",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnCompanyTimeOffList = [
  {
    key: "name",
    label: "Name",
    filter: false,
    sorter: false
  },
  {
    key: "start_date",
    label: "Start Date",
    filter: false,
    sorter: false
  },
  {
    key: "duration",
    label: "Duration",
    filter: false,
    sorter: false
  },
  {
    key: "type",
    label: "Type",
    filter: false,
    sorter: false
  },
  {
    key: "updatedAt",
    label: "Last Updated",
    filter: false,
    sorter: false
  },
  {
    key: "action",
    label: "",
    filter: false,
    sorter: false
  },
]

export const columnBalanceHistoryList = [
  {
    key: "request_id",
    label: "Request ID",
    filter: false,
    sorter: false,
  },
  {
    key: "event_name",
    label: "Event Name",
    filter: false,
    sorter: false,
  },
  {
    key: "request_type",
    label: "Request Type",
    filter: false,
    sorter: false,
  },
  {
    key: "duration",
    label: "Duration",
    filter: false,
    sorter: false,
  },
  {
    key: "status",
    label: "Status",
    filter: false,
    sorter: false,
  },
  {
    key: "balance_before",
    label: "Balance Before",
    filter: false,
    sorter: false,
  },
  {
    key: "balance_after",
    label: "Balance After",
    filter: false,
    sorter: false,
  },
  {
    key: "created_date",
    label: "Created Date",
    filter: false,
    sorter: false,
  },
];
